import { utl_parseData, html } from "../base/_utils";
import Papa from "papaparse";
import Modal from "bootstrap/js/dist/modal";
import "slick-slider";

/* ****************************************************** */
/*         Tips on Twirling and Training carousel         */
/* ****************************************************** */
$("#tips-on-twirling-and-training-carousel").slick({
    arrows: true,
    autoplay: true,
    dots: true,
    draggable: true,
    swipe: true,
    pauseOnHover: true,
    cssEase: "ease",
    accessibility: true,
    autoplaySpeed: 7000,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 2200,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1441,
            settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});

/* ****************************************************** */
/*                       PAPA PARSE                       */
/* ****************************************************** */

async function getAndDisplayData(dataRef) {
    const centralRegionData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=0&single=true&output=csv";

    const mideastRegionData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=1969238576&single=true&output=csv";

    const northeastRegionData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=204387442&single=true&output=csv";

    const southeastRegionData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=1565742300&single=true&output=csv";

    const westernRegionData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=484642971&single=true&output=csv";

    const stateCouncilSitesData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=233651517&single=true&output=csv";

    let results;
    let data;

    try {
        if (dataRef === "centralRegion") {
            // 'await' allows/prevents execution of parseData() depending on resolution/rejection of Promise(from parseData())
            results = await utl_parseData(centralRegionData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("central-region-list").innerHTML += html`
                    <td>${data[i].varTitle}</td>
                    <td>${data[i].varName}</td>
                    <td>${data[i].varLocation}</td>
                    <td>${data[i].varPhone}</td>
                    <td><a href="mailto:${data[i].varEmail}">${data[i].varEmail}</a></td>
                `;
            }
        } else if (dataRef === "mideastRegion") {
            // Additional Donors
            results = await utl_parseData(mideastRegionData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("mideast-region-list").innerHTML += html`
                    <td>${data[i].varTitle}</td>
                    <td>${data[i].varName}</td>
                    <td>${data[i].varLocation}</td>
                    <td>${data[i].varPhone}</td>
                    <td><a href="mailto:${data[i].varEmail}">${data[i].varEmail}</a></td>
                `;
            }
        } else if (dataRef === "northeastRegion") {
            // Additional Donors
            results = await utl_parseData(northeastRegionData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("northeast-region-list").innerHTML += html`
                    <td>${data[i].varTitle}</td>
                    <td>${data[i].varName}</td>
                    <td>${data[i].varLocation}</td>
                    <td>${data[i].varPhone}</td>
                    <td><a href="mailto:${data[i].varEmail}">${data[i].varEmail}</a></td>
                `;
            }
        } else if (dataRef === "southeastRegion") {
            // Additional Donors
            results = await utl_parseData(southeastRegionData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("southeast-region-list").innerHTML += html`
                    <td>${data[i].varTitle}</td>
                    <td>${data[i].varName}</td>
                    <td>${data[i].varLocation}</td>
                    <td>${data[i].varPhone}</td>
                    <td><a href="mailto:${data[i].varEmail}">${data[i].varEmail}</a></td>
                `;
            }
        } else if (dataRef === "westernRegion") {
            // Additional Donors
            results = await utl_parseData(westernRegionData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("western-region-list").innerHTML += html`
                    <td>${data[i].varTitle}</td>
                    <td>${data[i].varName}</td>
                    <td>${data[i].varLocation}</td>
                    <td>${data[i].varPhone}</td>
                    <td><a href="mailto:${data[i].varEmail}">${data[i].varEmail}</a></td>
                `;
            }
        } else if (dataRef === "stateCouncilSites") {
            // Additional Donors
            results = await utl_parseData(stateCouncilSitesData, Papa);
            data = results.data;

            for (let i = 0; i < data.length; i++) {
                document.getElementById("state-council-websites-list").innerHTML += html`
                    <td>${data[i].varStateCouncil}</td>
                    <td><a href="${data[i].varWebsite}" target="_blank">Visit Website for More Information</a></td>
                `;
            }
        }
    } catch (error) {
        // If Promise rejects, log the error
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData("centralRegion");
getAndDisplayData("mideastRegion");
getAndDisplayData("northeastRegion");
getAndDisplayData("southeastRegion");
getAndDisplayData("westernRegion");
getAndDisplayData("stateCouncilSites");
